<div 
  fxLayout="row" 
  fxLayoutAlign="center center" 
  class="eca-main-container">
  <div 
    fxFlex.xl="1300px" 
    fxFlex.lg="1000px" 
    fxFlex.md="900px" 
    class="eca-main-content">
    <mat-card>
      <h1>Access Denied</h1>
      <p>We are sorry, but you do not have sufficient permission to proceed.</p>
    </mat-card>
  </div>
</div>